import React from 'react';
import Card from '@mui/material/Card';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { useTheme } from '@mui/material/styles';
import ourValuesData from '../../constants/team/our-values';
import { STACK_CENTER_COLUMN_DIRECTION } from '../../constants/mui-components';
import {
  containerStack,
  headerStack,
  titleTypography,
  descriptionTypography,
  valuesGrid,
  valueCard,
  valueTitleTypography,
  valueDescriptionTypography,
} from './styles/our-values.styles';
import CorporativeVideoComponent from './CorporativeVideoComponent';

function OurValues() {
  const theme = useTheme();
  return (
    <Stack className={STACK_CENTER_COLUMN_DIRECTION} sx={containerStack}>
      <Stack className={STACK_CENTER_COLUMN_DIRECTION} sx={headerStack}>
        <Typography variant="large_2" sx={titleTypography(theme)}>
          {ourValuesData.title}
        </Typography>
        <Typography variant="medium_1" sx={descriptionTypography}>
          {ourValuesData.description}
        </Typography>
      </Stack>
      <Stack sx={valuesGrid}>
        {ourValuesData.values.map((value) => (
          <Card key={value.id} sx={valueCard(theme)}>
            {value.icon && value.icon}
            <Typography variant="medium_2" sx={valueTitleTypography}>
              {value.title}
            </Typography>
            <Typography variant="small_2" sx={valueDescriptionTypography}>
              {value.description}
            </Typography>
          </Card>
        ))}
      </Stack>
      <CorporativeVideoComponent />
    </Stack>
  );
}

export default OurValues;
